import { render, staticRenderFns } from "./Mpanel.vue?vue&type=template&id=6fce34e6&scoped=true"
import script from "./Mpanel.vue?vue&type=script&lang=js"
export * from "./Mpanel.vue?vue&type=script&lang=js"
import style0 from "./Mpanel.vue?vue&type=style&index=0&id=6fce34e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fce34e6",
  null
  
)

export default component.exports